import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { type FormControl, type FormGroup, ReactiveFormsModule } from '@angular/forms';

import { formSignalValue } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { ProsemirrorBasicConfigDirective, WysiwygComponent } from '@core/prosemirror-legacy/webapp';
import type { DynamicFormConfig } from '@tellent-ask-hr/dynamic-forms-types';

import { DefineFormWrapperComponent } from '../../partials/define-form-wrapper/define-form-wrapper.component';

@Component({
  selector: 'wysiwyg-infobox',
  imports: [
    DefineFormWrapperComponent,
    ProsemirrorBasicConfigDirective,
    TranslatePipe,
    ReactiveFormsModule,
    WysiwygComponent,
  ],
  template: `
    <rt-define-form-wrapper
      [defineForm]="defineForm()"
      [respondKindIcon]="defineConfig().icon"
      [respondKindName]="defineConfig().name"
      (duplicate)="duplicate.emit()"
      (delete)="delete.emit()"
      (changeTemplate)="changeTemplate.emit($event)"
    >
      <rt-wysiwyg
        prosemirrorBasicConfig
        [formControl]="defineForm().controls.textJson"
        [withBorder]="false"
        [placeholder]="'tlc.dynamic_form.define.infobox_placeholder' | translate"
      />
    </rt-define-form-wrapper>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WysiwygInfoboxComponent {
  public defineConfig = input.required<DynamicFormConfig['defineConfig']>();
  public defineForm = input.required<
    FormGroup<{
      textJson: FormControl<string>;
    }>
  >();

  public duplicate = output();
  public delete = output();
  public changeTemplate = output<string>();

  protected defineFormValue = formSignalValue(this.defineForm);
}
